export default class formConfig {
  // 区管单位
  static configList() {
    return [
      {
        title: "交易目录表详情",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "交易目录编号：",
            type: "input",
            value: "transactionCode",
            placeholder: "请输入",
            maxlength: 20,
            rule: {
              required: true,
              message: "请填写交易目录编号",
              trigger: "blur"
            }
          },
          {
            label: "交易目录名称：",
            type: "input",
            value: "transactionName",
            placeholder: "请输入",
            maxlength: 100,
            rule: {
              required: true,
              message: "请填写交易目录名称",
              trigger: "blur"
            }
          },
          {
            label: "上级目录名称：",
            type: "cascader",
            value: "pid",
            placeholder: "请输入",
            url: "/transactionDirectory/TransactionDirectoryComboTree?editFlg=true",
            required: true,
            rule: {
              required: false,
              message: "请选择上级目录名称",
              trigger: "blur"
            },
            clearable: true,
            propsData: {
              value: "id",
              label: "transactionName",
              children: "children",
              multiple: false,
              checkStrictly : true,
            },
          },
          {
            label: "是否废弃：",
            type: "select",
            value: "disused",
            placeholder: "请输入",
            optionData: [
              { name: "否", value: "0" },
              { name: "是", value: "1" },
            ],
            rule: {
              required: true,
              message: "请选择是否废弃",
              trigger: "blur"
            }
          },
          {
            label: "备注：",
            value: "remark",
            type: "textarea",
            required: true,
            maxlength: 500,
            minRows: "3",
            maxRows: "2",
            width: "100%;"
          },
        ]
      },
      {
        title: "区域部门信息",
        name: "2",
        icon: "",
        formConfigList: [
          {
            label: "",
            type: "slot",
            slotName: "list",
            class: "formList"
          }
        ]
      },
    ];
  }
}
